/**
 * SC-4 — 주택형 표시 정규화 (2026-09-21 · 회부_SC).
 *
 * 청약홈 원본(`apt_subscriptions.house_type_info[].type`)은 소수 4자리를 달고 온다:
 *   `059.0000A` · `074.9802A` · `084.9896C` · `100.9161`
 * 화면에 그대로 내면 사람이 읽는 「59A · 84C」와 다른 물건처럼 보이고,
 * 「84A 분양가」류 검색어와도 매칭되지 않는다.
 *
 * ⛔ **값을 바꾸지 않는다.** 이 함수는 «표시» 만 고른다 — 면적 계산은 원본 문자열을
 *    계속 쓴다(`parseFloat` 경로 무접촉). 저장 데이터도 손대지 않는다.
 * ⚠️ 반올림하지 않고 **정수부만** 취한다. 청약홈 주택형 번호는 관례상 정수부가 이름이고
 *    (`059.9847B` → 「59B」, 「60B」가 아니다), 반올림하면 같은 단지 안에서 두 타입이
 *    같은 이름이 될 수 있다.
 * ⚠️ 모르는 모양은 **원본 그대로 돌려준다**. 지어내지 않는다 —
 *    공공/임대 계열에 `059.0000A-1`·`전용59` 처럼 다른 표기가 섞여 들어온다.
 */

/** `059.0000A` → `59A`. 모양이 안 맞으면 원본 그대로. */
export function areaTypeLabel(raw: unknown): string {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  // 숫자(소수 허용) + 선택적 영문 꼬리. 그 밖은 건드리지 않는다.
  const m = /^(\d{1,4})(?:\.\d+)?\s*([A-Za-z]?)$/.exec(s);
  if (!m) return s;
  const n = Number(m[1]);
  if (!Number.isFinite(n) || n <= 0) return s;
  return `${n}${m[2].toUpperCase()}`;
}
